var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15781_3386",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.0712891,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15781_3386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.75 18.8214H15.5C15.2875 18.8214 15.1094 18.7495 14.9656 18.6057C14.8219 18.4619 14.75 18.2837 14.75 18.0711C14.75 17.8585 14.8219 17.6804 14.9656 17.5368C15.1094 17.3932 15.2875 17.3214 15.5 17.3214H17.75V15.0714C17.75 14.8589 17.8219 14.6808 17.9657 14.5371C18.1095 14.3933 18.2877 14.3214 18.5003 14.3214C18.7129 14.3214 18.891 14.3933 19.0346 14.5371C19.1782 14.6808 19.25 14.8589 19.25 15.0714V17.3214H21.5C21.7125 17.3214 21.8906 17.3933 22.0344 17.5371C22.1781 17.6809 22.25 17.8591 22.25 18.0717C22.25 18.2843 22.1781 18.4624 22.0344 18.606C21.8906 18.7496 21.7125 18.8214 21.5 18.8214H19.25V21.0714C19.25 21.2839 19.1781 21.462 19.0343 21.6058C18.8904 21.7495 18.7122 21.8214 18.4997 21.8214C18.2871 21.8214 18.109 21.7495 17.9654 21.6058C17.8218 21.4621 17.75 21.2839 17.75 21.0714V18.8214ZM5.8077 19.5714C5.30257 19.5714 4.875 19.3964 4.525 19.0464C4.175 18.6964 4 18.2688 4 17.7637V6.37913C4 5.874 4.175 5.44643 4.525 5.09643C4.875 4.74643 5.30257 4.57143 5.8077 4.57143H7.19233V3.22525C7.19233 3.00732 7.26618 2.82464 7.41388 2.6772C7.56156 2.52977 7.74457 2.45605 7.9629 2.45605C8.18122 2.45605 8.36378 2.52977 8.51058 2.6772C8.65736 2.82464 8.73075 3.00732 8.73075 3.22525V4.57143H14.3077V3.20603C14.3077 2.99353 14.3796 2.81541 14.5234 2.67166C14.6672 2.52792 14.8454 2.45605 15.058 2.45605C15.2706 2.45605 15.4486 2.52792 15.5922 2.67166C15.7358 2.81541 15.8076 2.99353 15.8076 3.20603V4.57143H17.1922C17.6974 4.57143 18.125 4.74643 18.475 5.09643C18.825 5.44643 19 5.874 19 6.37913V12.2868C18.75 12.256 18.5 12.2407 18.25 12.2407C18 12.2407 17.75 12.256 17.5 12.2868V10.3791H5.49997V17.7637C5.49997 17.8406 5.53202 17.9111 5.59612 17.9753C5.66024 18.0394 5.73077 18.0714 5.8077 18.0714H12.6442C12.6442 18.3214 12.6596 18.5714 12.6904 18.8214C12.7211 19.0714 12.7776 19.3214 12.8596 19.5714H5.8077ZM5.49997 8.87916H17.5V6.37913C17.5 6.3022 17.4679 6.23167 17.4038 6.16756C17.3397 6.10346 17.2692 6.07141 17.1922 6.07141H5.8077C5.73077 6.07141 5.66024 6.10346 5.59612 6.16756C5.53202 6.23167 5.49997 6.3022 5.49997 6.37913V8.87916Z",
    fill: "#40484C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarAdd);
export default __webpack_public_path__ + "static/media/calendar-add.a0eba064f093557f18015380bba4bd4c.svg";
export { ForwardRef as ReactComponent };